'use strict';

function handle() {}

module.exports = function report(url) {
	var reportObj = document.createElement("img");
	reportObj.onerror = handle;
	reportObj.onload = handle;
	reportObj.onabort = handle;
	reportObj.src = url;
	//setTimeout(handle, 100);
};
